import { List } from 'immutable';
import { parseAccounts } from './accounts';
import { parseWrappedConsents, indexConsents } from './consents';
import { processAccessConsents } from './access-consents';
import { processPaymentConsents } from './payment-consents';
import { processStandingOrderConsents } from './standing-order-consents';
import { processVrpConsents } from './vrp-consents';
import { processSweepingConsents } from './sweeping-consents';
import { processFundsCheckConsents } from './funds-check-consents';
import { processBiometricConsents } from './biometric-consents';
import { processMortgageConsents } from './mortgage-consents';
import { hasChannel } from './consent-utils';
var updateCreatedBy = function updateCreatedBy(customer) {
  return function (consent) {
    return consent.update('createdBy', function (createdBy) {
      return customer.get('customerType') === 'cpb' ? createdBy : "".concat(customer.get('lastName'), " ").concat(customer.get('firstName')[0], ".");
    });
  };
};
export var setCustomerType = function setCustomerType(customerType) {
  return function (customerDetails) {
    return customerDetails.setIn(['customer', 'customerType'], customerType);
  };
};

/* 
Temp hotfix to exclude clientIds - https://natwest.atlassian.net/browse/OB-19435

TPP:
5A9kieEHj42hHdNic6mWbvrbs - CEP - Customer Engagement Platform PROD

Cora:
3zIGK2auTXeVn3exMiWwokrbs (NWB)
Sh7avaWC2fHUMAyZ7F9kUrbs (RBS)
1DMWFD8hsZMzEQETc0CPrZrbs (UBN) 
*/

var listExcludeClientIds = ['5A9kieEHj42hHdNic6mWbvrbs', '3zIGK2auTXeVn3exMiWwokrbs', 'Sh7avaWC2fHUMAyZ7F9kUrbs', '1DMWFD8hsZMzEQETc0CPrZrbs'];
var excludeClientIds = function excludeClientIds(consent) {
  return !listExcludeClientIds.includes(consent.getIn(['consent', 'clientId']));
};
export var setCustomerDetails = function setCustomerDetails(customerDetails) {
  var skipUnsupportedConsents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (state) {
    var customer = customerDetails.get('customer');
    var features = customerDetails.get('features', List([])).toOrderedSet();
    var accounts = parseAccounts(customerDetails.get('accounts'));
    var consents = parseWrappedConsents(customerDetails.get('consents').filter(excludeClientIds), accounts, skipUnsupportedConsents).map(updateCreatedBy(customer));
    var channelIdToConsents = consents.groupBy(function (consent) {
      return consent.get('channelId');
    });
    var accesses = processAccessConsents(channelIdToConsents.get('OBAISP', List()));
    var payments = processPaymentConsents(consents.filter(hasChannel(['OBPISP', 'OBPISPBB'])));
    var standingOrders = processStandingOrderConsents(channelIdToConsents.get('OBPISPSO', List()));
    var vrp = processVrpConsents(channelIdToConsents.get('OBVRP', List()).filter(function (consent) {
      return !consent.getIn(['payload', 'sweeping']);
    }));
    var sweeping = processSweepingConsents(channelIdToConsents.get('OBVRP', List()).filter(function (consent) {
      return consent.getIn(['payload', 'sweeping']);
    }));
    var fundsChecks = processFundsCheckConsents(channelIdToConsents.get('OBCBPII', List()));
    var biometrics = processBiometricConsents(channelIdToConsents.get('IAMMFA', List()));
    var mortgages = processMortgageConsents(channelIdToConsents.get('HBO', List()));
    return state.set('customer', customer).set('accounts', accounts).set('features', features).setIn(['accesses', 'index'], indexConsents(accesses)).setIn(['payments', 'index'], indexConsents(payments)).setIn(['standingOrders', 'index'], indexConsents(standingOrders)).setIn(['vrp', 'index'], indexConsents(vrp)).setIn(['sweeping', 'index'], indexConsents(sweeping)).setIn(['fundsChecks', 'index'], indexConsents(fundsChecks)).setIn(['biometrics', 'index'], indexConsents(biometrics)).setIn(['mortgages', 'index'], indexConsents(mortgages));
  };
};